import * as React from "react";
import { UseFormReturn } from "react-hook-form";

import {
  RejectMatchFormValues,
  rejectMatchOptions,
} from "@/app/(discover)/candidate/invites/components/reject-match-modal/reject-match-form-schema";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";

export function RejectMatchExplanationInput({
  form,
}: {
  form: UseFormReturn<RejectMatchFormValues>;
}) {
  return (
    <FormField
      control={form.control}
      name="explanation"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Textarea placeholder="Please tell us more" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export function RejectMatchOptionsInput({
  form,
}: {
  form: UseFormReturn<RejectMatchFormValues>;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="reason"
        render={({ field }) => (
          <FormItem className="space-y-3">
            <FormControl>
              <RadioGroup onValueChange={field.onChange} value={field.value}>
                {Object.values(rejectMatchOptions).map((option) => (
                  <FormItem key={option.value} className="flex items-center">
                    <FormControl>
                      <RadioGroupItem value={option.value} id={option.value} />
                    </FormControl>
                    <Label
                      htmlFor={option.value}
                      className="cursor-pointer font-normal"
                    >
                      {option.label}
                    </Label>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
